import React from 'react';

/**
 * PageHeader — reusable header used on list pages (Projects, Travel, Career, etc.)
 *
 * Props:
 *   eyebrow    {string}  — e.g. "03 — Projects"
 *   title      {string}  — large Cormorant Garamond display title
 *   subtitle   {string}  — optional italic sub-line
 */
export default function PageHeader({ eyebrow, title, subtitle }) {
  return (
    <div style={{ marginBottom: '48px' }}>
      {eyebrow && (
        <div className="eyebrow" style={{ marginBottom: '12px' }}>
          {eyebrow}
        </div>
      )}
      <h1 className="page-title" style={{ fontSize: 'clamp(2.8rem, 6vw, 5rem)', margin: 0 }}>
        {title}
      </h1>
      {subtitle && (
        <p style={{
          fontFamily: '"Cormorant Garamond", Georgia, serif',
          fontStyle: 'italic',
          fontSize: '1.25rem',
          color: 'var(--text-2)',
          marginTop: '12px',
          marginBottom: 0,
          lineHeight: 1.5,
        }}>
          {subtitle}
        </p>
      )}
    </div>
  );
}
